export interface CompanyConfig {
    logo: string | null;
    apiDomain: string;
}

export interface Config {
    [key: string]: CompanyConfig;
}

const config: Config = {
    localhost: {
        logo: "ania-logo.png",
        apiDomain: "https://test.admin.knowandbelive.it",
    },
    test: {
        logo: "ania-logo.png",
        apiDomain: "https://test.admin.knowandbelive.it",
    },
    fondazioneania: {
        logo: "ania-logo.png",
        apiDomain: "https://admin.knowandbelive.it",
    }
};

export default config;
